import { getActionLogs } from "app/api/action-log.api";
import { setLoading, setLogs, setError } from "./transfer-history.slice";

export const fetchTransferHistory = (params) => async (dispatch) => {
  dispatch(setLoading(true));
  try {
    const response = await getActionLogs({ ...params, action: "credit_transfer" });
    const paginated = response.data.data;
    dispatch(setLogs({
      logs: paginated?.data || [],
      total: paginated?.total || 0,
    }));
  } catch (error) {
    dispatch(setError(error.response?.data?.message || "Failed to fetch transfer history"));
  }
};
